import {IHierarchyBuilderService, IHierarchyComponents, LoadHierarchyOptions} from "./PA.MD.Services.IF";
import {DimensionType} from "../PA.Core/PA.Core.IF.Hierarchy";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from "axios";
import {ILoaderServiceRequest, ILoaderServiceResponse} from "../PA.Loader.Services/Loader";

export interface IHierarchyBuilderServiceRequest {
    requestType: string,
    dimensionType?: DimensionType,
    hierarchyId?: number | string
    options?: any | LoadHierarchyOptions
}

export interface IHierarchyBuilderServiceResponse {
    request: IHierarchyBuilderServiceRequest,
    bSuccess: boolean,
    sErrors: string[],
    sWarnings: string[],
    results: any | IHierarchyComponents
}

export class HierarchyBuilderService
    implements IHierarchyBuilderService
{

    async getHierarchyComponents(aDimensionType: DimensionType,
                                 HierarchyId: string | number,
                                 options: LoadHierarchyOptions): Promise<IHierarchyComponents>
    {
        return await this.makeRequest("getHierarchyComponents",
                                      aDimensionType, HierarchyId, options);
    }

    private async makeRequest(requestType: string,
                              dimensionType: DimensionType,
                              hierarchyId: string | number,
                              options: LoadHierarchyOptions): Promise<any>
    {

        let hbRequest: IHierarchyBuilderServiceRequest = {
            requestType: requestType,
            dimensionType: dimensionType,
            hierarchyId: hierarchyId
        }

        if (options)
            hbRequest.options = options

        try {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));

            if (sEndPoint.endsWith('/'))
                sEndPoint += 'hierarchyBuilder';
            else
                sEndPoint += '/hierarchyBuilder';

            let resp = await axios.post(sEndPoint, {data: {request: hbRequest}})

            let responseData: IHierarchyBuilderServiceResponse = resp.data;
            if ('request' in responseData) {
                if (!responseData.bSuccess) {
                    throw "Hierarchy Builder Service Response: " + (responseData.sErrors || ['Unknown']).toString()
                } else
                    return responseData.results

            } else
                throw 'Unable to parse Hierarchy Builder Web Response: ' + responseData;
        } catch (err) {
            throw 'Unable to obtain Hierarchy Builder Results from Server. ' + JSON.stringify(err)
        }
    }

}